const CANVAS_AUTH_URL = 'https://cedarville.instructure.com/login/oauth2/auth';
const CANVAS_TOKEN_URL = 'https://cedarville.instructure.com/login/oauth2/token';
const CANVAS_API_URL = 'https://cedarville.instructure.com/api/v1';
const CLIENT_ID = 'YOUR_CLIENT_ID';
const CLIENT_SECRET = 'YOUR_CLIENT_SECRET';
const REDIRECT_URI = 'http://localhost:3000/canvas-callback'; // Update this to match your app's URL

export const initiateCanvasLogin = () => {
  const authUrl = `${CANVAS_AUTH_URL}?client_id=${CLIENT_ID}&response_type=code&redirect_uri=${REDIRECT_URI}`;
  window.location.href = authUrl;
};

export const handleCanvasCallback = async (code) => {
  const response = await fetch(CANVAS_TOKEN_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams({
      grant_type: 'authorization_code',
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      redirect_uri: REDIRECT_URI,
      code: code,
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to obtain access token');
  }

  const data = await response.json();
  return data.access_token;
};

export const fetchCanvasCourses = async (accessToken) => {
  const response = await fetch(`${CANVAS_API_URL}/courses`, {
    headers: {
      'Authorization': `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch courses from Canvas');
  }

  const courses = await response.json();

  return courses.map(course => ({
    title: course.name,
    professor: '', // Canvas API doesn't provide professor info directly
    location: '', // Canvas API doesn't provide location info
    credits: '', // Canvas API doesn't provide credits info
    description: course.public_description || '',
    schedule: '', // Canvas API doesn't provide schedule info directly
  }));
};
